import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { Store } from '@ngxs/store';
import { ConvertLabels } from 'src/app/story/state/labels/story.labels.actions';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { filter, takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LabelRecipe } from 'src/app/story/models/labels/label-recipe.enum';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';

@Component({
  selector: 'app-conversion-alert',
  templateUrl: './conversion-alert.component.html',
  styleUrls: ['./conversion-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversionAlertComponent implements OnInit, OnDestroy {
  showConversionWarning = false;

  private ngUnsubscribe = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    // Labels are always converted when type is module
    this.store.select(StoryLabelsState.getLabels)
      .pipe(
        filter(labels => labels.length > 0),
        take(1),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.showConversionWarning = (
          this.activatedRoute.snapshot.queryParams.type === StoryType.Module &&
          this.storageService.getLocalJSON(StorageItemEnum.LabelConversionSeen) !== true
        );
      });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleOkClick() {
    this.hideWarning();
  }

  handleUndoClick() {
    this.hideWarning();

    const labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
    this.store.dispatch(new ConvertLabels(labels, LabelRecipe.Annotation));
  }

  hideWarning() {
    this.showConversionWarning = false;
    this.storageService.setLocalItem(StorageItemEnum.LabelConversionSeen, true);
  }
}
